import path from 'path'

// загрузка компонент из папки
function loadComponents(context) {
  const components = []
  context.keys().forEach((key) => {
    const name = path.basename(key, '.vue')
    components.push({ name, component: context(key).default })
  })
  return components
}

export default loadComponents
